import React, { useState, useEffect } from "react"

import ServicePageHeader from "../../components/layout-components/top/headers/service-page-header/ServicePageHeader.component"
import PageSection from "../PageSection/PageSection.component"
import { MainLayout, metaObjectI, ogObjectI } from "../main.layout"
import CenterContainer from "../containers/CenterContainer/CenterContainer.component"
import Footer from "../../components/layout-components/bottom/footer/Footer.component"
import MainCtaButton from "../../components/layout-components/_/buttons/MainCtaButton/MainCtaButton.component"
import { arrowColorType}  from "../../components/layout-components/_/sliders/SliderNav/SliderNav.component"

import { whatWeOffer } from "./css/whatWeOffer.css"
import { ourProcessCss } from "./sections/our-process/css/ourProcess.css.func"
import OurPreviousWork from "./sections/our-previous-work/OurPreviousWork.section";
import { FlattenSimpleInterpolation } from "styled-components"

export const layoutColorTypes = {
  YELLOW: "yellow",
  MAGENTA: "magenta",
  CYAN: "cyan",
}

interface ServicePageLayoutPropsI {

  meta?: metaObjectI;
  og?: ogObjectI;
  canonicalUrl?: string;

  layoutColorType?: string; // Use the exported `layoutColorType` to set this value.
  layoutColor?: string;
  layoutTextColor?: string; // Text that goes above the layoutColored background.
  testimonialPageNumberColor?: string;
  arrowColorType?: string;

  content: {
    title: string,
    whatWeOffer: {
      leftPart: string,
      rightPart: string
    },
    processText: string,
    testimonials?: Array<{
      title: string,
      text: string,
      stars: number
    }>
  },

  rightHeroImage: string;
  headerIcon: string;
  desktopMainMenuTextColor?: string;

}

export const ServicePageLayout: React.FC<ServicePageLayoutPropsI> = (props) => {

  let layoutColor = "#FCEDBD";
  let layoutTextColor = "black";
  let _arrowColorType = arrowColorType.YELLOW;
  let testimonialPageNumberColor = "black";
  
  switch (props.layoutColorType) {

    case layoutColorTypes.YELLOW: {
      // default values
    } break;

    case layoutColorTypes.MAGENTA: {
      layoutColor = "#bf469f";
      layoutTextColor = "white";
      _arrowColorType = arrowColorType.WHITE;
      testimonialPageNumberColor = "white";
    } break;

    case layoutColorTypes.CYAN: {
      layoutColor = "#1bd4e9";
      layoutTextColor = "white";
      _arrowColorType = arrowColorType.WHITE;
      testimonialPageNumberColor = "white";
    } break;
  
    default: {
      // Will use default values.
    } break;
  }

  /** Override with props */
  if (props.layoutColor) {
    layoutColor = props.layoutColor;
  }
  if (props.layoutTextColor) {
    layoutTextColor = props.layoutTextColor;
  }
  if (props.testimonialPageNumberColor) {
    testimonialPageNumberColor = props.testimonialPageNumberColor;
  }

  return (

    <MainLayout 
      meta={props.meta ?? undefined} 
      og={props.og ?? undefined} 
      canonicalUrl={props.canonicalUrl ?? undefined}>

      {/* 
      
            Header

      */}

      <ServicePageHeader 
        data={
          {
            heading: props.content.title,
            buttonText: "Hire Us",
            rightHeroImage: props.rightHeroImage, // "img_contnet_writing_full.jpg",
            backgroundColor: layoutColor, // "#FCEDBD",
            textColor: layoutTextColor ?? "black",
            headerIcon: props.headerIcon // "/ico_guest_blogging_headerv2b@2x.png" "/ico_smm_header.png" "/ico_content_writing_2@2x.png"
          }
        } 
        desktopMainMenuTextColor={props.desktopMainMenuTextColor ?? undefined}
      />



      {/* 
      
            "What we offer"

      */}

      <PageSection extendStyles={whatWeOffer}>

        <h2 className="section-title">What we offer?</h2>

        <div className="texts">
          <p className="texts--left">{props.content.whatWeOffer.leftPart}</p>
          <p className="texts--right">{props.content.whatWeOffer.rightPart}</p>
        </div>

        <div className="background-box" />

      </PageSection>
      


      {/* 
      
            "Our ___ process"

      */}

      <PageSection 
        extendStyles={ourProcessCss(
          {
            backgroundColor: layoutColor,
            titleColor: layoutTextColor
          }) as unknown as FlattenSimpleInterpolation} 
        fullWidth={true}>

        <CenterContainer>

          <div className="background-box" />

          <h2 className="section-title">{props.content.processText}</h2>

          <MainCtaButton 
            buttonText="Hire Us" />

        </CenterContainer>

      </PageSection>



      {/* 
      
            "Our previous work"

      */}

      <OurPreviousWork 
        testimonials={props.content.testimonials!}
        testimonialsBackgroundColor={layoutColor}
        arrowColorType={_arrowColorType}
        pageNumberColor={testimonialPageNumberColor}
        activePageUnderlineColor={testimonialPageNumberColor}
      />



      {/* 
      
            Footer

      */}

      <Footer />



    </MainLayout>


  )
}